import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import store from 'utils/store';
function useLocalStorage(localStorageKey, defaultValue) {
  var storedData = store.getItem(localStorageKey);
  var _useState = useState(storedData || defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  if (!storedData) {
    store.setItem(localStorageKey, defaultValue);
  }
  function updateLocalStorageValue(newValue) {
    store.setItem(localStorageKey, newValue);
    setValue(newValue);
  }
  function deleteLocalStorageValue() {
    store.removeItem(localStorageKey);
    setValue(undefined);
  }
  return [value, updateLocalStorageValue, deleteLocalStorageValue];
}
export default useLocalStorage;